import PageLayout from 'pages/ViewQuiz/PageLayout';
import PageProvider from 'pages/ViewQuiz/PageProvider';

const ViewQuizPage = () => (
    <PageProvider>
        <PageLayout />
    </PageProvider>
);

export default ViewQuizPage;
